import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32e70008"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = {
  id: "chargebacks_action_toolbar",
  class: "container-fluid d-flex flex-column flex-md-row flex-md-stack container-xxl"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-gray-700 fw-bold pe-3" }, "Actions:", -1))
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "btn btn-sm btn-icon btn-light btn-active-color-success h-30px w-30px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "d-flex flex-aligns-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<span class=\"fs-8 fw-bold text-gray-700 ps-1 me-2\" data-v-32e70008>Quick Edit:</span><span class=\"indicator-label\" data-v-32e70008><img alt=\"\" class=\"w-30px h-28px\" src=\"/media/svg/files/pdf.svg\" data-v-32e70008></span><span class=\"indicator-progress\" data-v-32e70008><span class=\"spinner-border spinner-border-sm align-middle ms-2\" data-v-32e70008></span></span>", 3)
const _hoisted_15 = [
  _hoisted_12
]
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-gray-700 fw-bold ps-1 me-2" }, "Response Packet:", -1))
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-lg badge-light text-primary align-self-center fs-8 px-2"
}
const _hoisted_20 = {
  key: 1,
  class: "badge badge-lg badge-light align-self-center fs-8 px-2"
}
const _hoisted_21 = { class: "d-flex align-items-center ms-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-gray-700 fw-bold ps-1 me-2" }, "Chargeback Score:", -1))
const _hoisted_23 = {
  key: 0,
  class: "badge badge-lg badge-light-success align-self-center fs-8 px-2"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-light text-primary align-self-center fs-8 px-2"
}
const _hoisted_25 = {
  key: 2,
  class: "badge badge-light text-danger align-self-center fs-8 px-2"
}
const _hoisted_26 = {
  key: 3,
  class: "badge badge-lg badge-light align-self-center fs-8 px-2"
}
const _hoisted_27 = {
  key: 0,
  class: "toolbar custom-progress-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ChargebackActions = _resolveComponent("ChargebackActions")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs027.svg" })
                ])
              ]),
              _createVNode(_component_ChargebackActions, {
                incomingData: _ctx.incoming,
                onReloadIncoming: _ctx.reloadIncoming,
                onOpenDrawer: _ctx.onOpenResponseDrawer,
                onFormEntry: _ctx.onFormEntry,
                onTriggerAction: _ctx.onAction,
                apiSyncItems: _ctx.apiSyncItems,
                connections: _ctx.connections
              }, null, 8, ["incomingData", "onReloadIncoming", "onOpenDrawer", "onFormEntry", "onTriggerAction", "apiSyncItems", "connections"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm",
              disabled: 
                _ctx.incoming.dispute_url === '' ||
                _ctx.incoming.transaction_found === '0' ||
                _ctx.incoming.details_populated !== '4'
              ,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOpenResponseDrawer && _ctx.onOpenResponseDrawer(...args)), ["prevent"])),
              ref: "openResponseDrawerBtn"
            }, _hoisted_15, 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_ctx.getIncomingPercent > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "completed"))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "incomplete"))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            (Number(_ctx.incoming.response_score) >= 75.00)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.incoming.response_score) + "%", 1))
              : (Number(_ctx.incoming.response_score >= 50.00) && Number(_ctx.incoming.response_score) <= 74.00)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.incoming.response_score) + "%", 1))
                : (Number(_ctx.incoming.response_score > 0.00) && Number(_ctx.incoming.response_score) <= 49.00)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.incoming.response_score) + "%", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.incoming.response_score) + "%", 1))
          ])
        ])
      ])
    ]),
    (_ctx.showProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_el_progress, {
            percentage: 50,
            indeterminate: true,
            "show-text": false
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}